import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import './chunk-17b33cd2.js';
import './chunk-7e17a637.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-83c8b459.js';
import { A as Autocomplete } from './chunk-b0123b89.js';
export { A as BAutocomplete } from './chunk-b0123b89.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;
